import { Modal } from "react-bootstrap";
import { Link } from "react-router-dom";

const LoginModal = ({ show, onHide }) => {
  const onCloseModal = () => {
    onHide();
  };

  return (
    <Modal show={show} onHide={onCloseModal} className="login_modal" centered>
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Login Required
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="modal-icon">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="32"
            height="32"
            fill="currentColor"
            viewBox="0 0 16 16"
          >
            <path d="M8 1a2 2 0 0 1 2 2v4H6V3a2 2 0 0 1 2-2zm3 6V3a3 3 0 0 0-6 0v4a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2z" />
          </svg>
        </div>
        <p className="modal-message">
          You need to be logged in to access this feature. Please log in to
          continue.
        </p>
      </Modal.Body>
      <Modal.Footer>
        <button className="close_btn" onClick={onCloseModal}>
          Close
        </button>
        <Link to="/login" className="login_btn">
          Go to Login
        </Link>
      </Modal.Footer>
    </Modal>
  );
};

export default LoginModal;
